import { render, staticRenderFns } from "./ProductDetailsModal.vue?vue&type=template&id=35b752d4&scoped=true&"
import script from "./ProductDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsModal.vue?vue&type=style&index=0&id=35b752d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b752d4",
  null
  
)

export default component.exports